import React from "react";
import {
  Box,
  Flex,
  Heading,
  Image,
  ListItem,
  UnorderedList,
} from "@chakra-ui/react";
import Ajay_pic from "./Images/pic.JPG";

const About = () => {
  return (
    <Box
      id="about"
      paddingTop={"15vh"}
      Width={"100vw"}
      className="about section"
    >
      <Heading
        as={"h3"}
        fontSize="4xl"
        fontWeight="600"
        margin="auto"
        textAlign="center"
      >
        About Me
      </Heading>
      <Flex
        height={{ base: "95vh", md: "60vh", lg: "55vh" }}
        width="85%"
        margin="auto"
        flexDir={{ base: "column", md: "row", lg: "row" }}
      >
        <Box
          data-aos="fade-down"
          width={{ base: "100%", md: "50%", lg: "35%" }}
          marginTop={"30px"}
        >
          <Image
            className="home-img"
            margin="auto"
            border="4px solid teal"
            borderRadius="10%"
            src={Ajay_pic}
            width={"290px"}
            height={"340px"}
          />
        </Box>
        <Box
          padding={{ base: "0px", md: "40px", lg: "50px" }}
          marginTop={{ base: "30px", md: "20px", lg: "30px" }}
          alignItems="center"
          alignContent="center"
          height="100%"
          width={{ base: "100%", md: "50%", lg: "65%" }}
          data-aos="fade-up"
        >
          <UnorderedList id="user-detail-intro" textAlign={"justify"}>
            <ListItem>
              Hello! My name is <b>Ajay</b> & I enjoy creating things that live
              on the internet. I'm a <b>Passionate Developer</b>, with strong
              administrative & communication skills, good attention to detail &
              the ability to write efficient code.
            </ListItem>
            <ListItem my={8}>
              {" "}
              I am currently serving as a <b>Software Engineer</b> at{" "}
              <b>sGate Tech Solutions Pvt. Ltd.</b> After completing{" "}
              <b>Full Stack Web Development</b> course from <b>Masai School</b>,
              I got this opportunity and achieved this milestone. As I begin the
              next chapter of my career, my goal is not only to continue honing
              my skills but also to leverage my expertise to drive meaningful
              contributions to my team and organization.
            </ListItem>
          </UnorderedList>
        </Box>
      </Flex>
    </Box>
  );
};

export default About;
